// Land ApplicationsXXX
// My Applications

<template>
<div class="lms4500 container whitesmoke curved">

  <div class="content board whitesmoke">
    <Ul class="crumbs text-charcoal mb-2">
      <li><sym-link to="/">Home</sym-link></li>
      <li><sym-link to="lms1040">Portal</sym-link></li>
      <!-- <li><span aria-current="page">Land Applications</span></li> -->
      <li><span aria-current="page">My Applications</span></li>
    </Ul>

    <div class="page-title lams curved border-lightgray mb-4">
      <!-- <h5 class="serif"><i class="fa fa-copy fa-lg ml-1 mr-2"></i>Land Applications</h5> -->
      <h5 class="serif mb-0"><i class="fa fa-copy fa-lg ml-1 mr-2"></i>My Applications</h5>
    </div>

    <div class="text-center mb-2" >
      <sym-combo v-model="regionId" :input-width="68" display-field="regionFullName" :datasource="regions" @changing="onRegionIdChanging" @changed="onRegionIdChanged"></sym-combo>
    </div>

    <div class="d-flex justify-center align-items-center primary-light border-main p-1 curved mb-2" v-if="!hasApplications">
      <span class="lg-1"><i class="fa fa-info-circle fa-lg mr-2"></i>No applications found.</span>
    </div>

    <button type="button" class="info w-100 lg-2 shadow text-center mb-3" @click="go('lms4510')"><i class="fa fa-send-o mr-2"></i> Submit New Application</button>

    <div class="apps white" v-show="apps.length">
      <div class="border-main curved-1 p-2 shadow" v-for="(app, index) in apps" :key="index">
        <table class="mb-0">
          <tbody class="lg-1">
            <tr class="table-hidden-row">
              <td class="w-40"></td>
              <td class="w-60"></td>
            </tr>
            <tr v-show="!app.isUploadCompleted">
              <td colspan="2">
                <sym-alert class="primary-light border-main mb-0" icon="warning">
                  This application cannot be processed. You need to upload your supporting documents (in PDF format).
                </sym-alert>
             </td>
            </tr>
            <tr v-if="!app.transactionId">
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Request Number</td>
              <td class="w-60 bold">{{ app.appId }}</td>
            </tr>
            <tr v-if="app.transactionId">
              <td class="w-40 info-label py-2" :class="getInfoLabelClass(app)">Transaction</td>
              <td class="w-60 py-1">
                <div class="d-flex justify-between">
                  <span class="bold pt-1">{{ app.transactionId }}</span>
                  <button type="button" class="info px-3 sm-1 shadow mb-0" v-if="app.transactionId" @click="onShowRoutings(app.transactionId)" @mousedown="onButtonMouseDown">Details</button>
                </div>
              </td>
            </tr>
            <tr>
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Application Type</td>
              <td class="w-60 bold">{{ app.applicationTypeName }}</td>
            </tr>

            <tr>
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Date Filed</td>
              <td class="w-60 bold">{{ core.toDateDisplayFormat(app.dateFiled) }}</td>
            </tr>
            <tr>
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Status</td>
              <!-- <td class="w-60 bold">{{ app.trxStatusDescription }}</td> -->
              <td class="w-60 bold" :class="getTrxStatusColorClass(app)">{{ app.trxStatusDescription }}</td>
            </tr>
            <tr v-if="app.trxStatusId === 'P'">
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Remarks</td>
              <td class="w-60 bold primary-light">{{ app.remarks }}</td>
            </tr>
            <tr v-if="app.trxStatusId === 'X'">
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Reason</td>
              <td class="w-60 bold primary-light">{{ app.rejectReason }}</td>
            </tr>
            <tr>
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Applicant Name</td>
              <td class="w-60 bold">{{ app.applicantName }}</td>
            </tr>
            <tr>
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Lot Number</td>
              <td class="w-60 bold">{{ app.requestedLot }}</td>
            </tr>
            <tr>
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Block Number</td>
              <td class="w-60 bold">{{ app.blockNumber }}</td>
            </tr>
            <tr>
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Location</td>
              <td class="w-60 bold">{{ app.requestedLocation }}</td>
            </tr>
            <tr>
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Area</td>
              <td class="w-60 bold">{{ core.toDecimalFormat(app.area) }}</td>
            </tr>
            <tr>
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Survey Number</td>
              <td class="w-60 bold">{{ app.surveyPlan }}</td>
            </tr>
            <tr>
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Lot Details</td>
              <td class="w-60 bold">{{ app.lotDetails }}</td>
            </tr>
            <tr>
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Document/s</td>
              <td class="w-60 bold">{{ app.documentCount }}</td>
            </tr>
            <tr v-if="app.instructions">
              <td class="w-40 info-label" :class="getInfoLabelClass(app)">Instructions to Client</td>
              <td class="w-60 bold lams-light">{{ app.instructions }}</td>
            </tr>
          </tbody>
          <tfoot v-if="!app.transactionId && app.trxStatusId !== 'X'">
            <tr>
              <td colspan="2">
                <sym-alert class="primary-light border-main" icon="warning" v-show="!app.documentCount">
                  This application cannot be processed. You need to upload your supporting documents (in PDF format).
                </sym-alert>

                <div class="text-center">
                  <button type="button" class="fw-26 warning lg-1 border-main shadow mb-0 mr-2" title="Edit application" @click="onEdit(app.appId)"><i class="fa fa-edit mr-2"></i> Edit</button>
                  <button type="button" class="fw-26 warning lg-1 border-main shadow mb-0" title="Upload documents" @click="onUpload(app.appId)"><i class="fa fa-upload mr-2"></i> Upload</button>
                </div>
                <div class="pt-3 pb-1">
                  <!-- <a href="./res/pla/Form-RFP.pdf" download class="button info lg-1 border-main shadow-dark w-100 text-center" @mousedown="onButtonMouseDown"><i class="fa fa-download mr-2"></i>Download Application Form</a> -->
                  <!-- <a :href="getAppFormName(app)" download class="button info lg-1 border-main shadow-dark w-100 text-center" @mousedown="onButtonMouseDown"><i class="fa fa-download mr-2"></i>Download Application Form</a> -->
                </div>
              </td>
            </tr>
          </tfoot>
        </table>

      </div>
    </div>

    <button type="button" class="primary text-center w-100 lg-1 shadow mt-3 mb-2" @click="goBack()"><i class="fa fa-arrow-left mr-2"></i> Back</button>

  </div>

  <sym-modal
    v-model="isModalVisible"
    size="lg"
    :header="false"
    :customBody="true"
    :footer="false"
    :backdrop="false"
    v-if="isModalVisible"
  >
    <div class="p-1 mb-0">
      <div class="curved border-dark lams-light p-2 text-center">
        <p class="lams p-2 curved-top mb-0 lg-2">Details of Transaction: <span class="bold display-9">{{ routings[0].transactionId }}</span></p>

        <table class="mb-2 table-scroll">
          <thead>
            <tr class="text-charcoal">
              <th class="w-15">Date / Time</th>
              <th class="w-20">Workgroup</th>
              <th class="w-20">Assigned To</th>
              <th class="w-10">Status</th>
              <th class="w-20">Task</th>
              <th class="w-15">Remarks</th>
            </tr>

          </thead>

          <tbody class="white text-charcoal">
            <tr v-for="(routing, index) in routings" :key="index">
              <td>{{ core.toDateFormat(routing.createDate, true, 'dd MMM yyyy h:mmtt') }}</td>
              <td>{{ routing.workgroupDescription }}</td>
              <td>{{ routing.userName }}</td>
              <td>{{ routing.trxStatusDescription }}</td>
              <td>{{ routing.action }}</td>
              <td>{{ routing.remarks }}</td>
            </tr>
          </tbody>
        </table>

        <button type="button" class="warning w-100 text-center shadow lg-3 p-1 my-2" @click="isModalVisible=false">Close</button>

      </div>
    </div>
  </sym-modal>

</div>
</template>

<script>

import {
  get
} from '../../js/http';

import
  PageBase
from '../PageBase.vue';

export default {
  extends: PageBase,
  name: 'lms4500',

  data () {
    return {
      regions: [],
      regionId: 0,
      apps: [],

      routings: [],

      isModalVisible: false,
      isListLoaded: false

    };
  },

  computed: {
    hasApplications () {
      if (this.regions.length === 1) { return false; }
      if (this.regionId && !this.apps.length && this.isListLoaded ) { return false; }
      return true;
    }

  },

  methods: {

    // API calls

    getRegions () {
      return get('api/accounts/' + this.accountCode + '/regions');
    },

    getLinkStatus (regionId) {
      return get('api/regions/' + regionId + '/link-status');
    },

    getApplications () {
      return get('api/rgn/' + this.regionId + '/accounts/' + this.accountCode + '/apps');
    },

    getRoutings (transactionId) {
      return get('api/rgn/' + this.regionId + '/transactions/' + transactionId + '/routings');
    },

    // event handlers

    onRegionIdChanging (e) {
      const me = this;

      let regionInfo = me.regions.find( obj => obj.regionId === e.proposedValue );
      e.message = `Region '${regionInfo.regionFullName}' is offline.`;

      if (!regionInfo.apiHostAddress && regionInfo.regionId) {
        e.preventDefault();
        return;
      }

      if (e.proposedValue) {
        e.callback = me.regionIdCallback;
      }

    },

    regionIdCallback (e) {
      const
        me = this,
        wait = me.wait();

      return me.getLinkStatus(e.proposedValue).then(
        statusCode => {
          me.stopWait(wait);

          let isOnline = (statusCode === 200);
          return isOnline;
        },
        () => {
          me.stopWait(wait);
          return false;

        }
      );

    },

    onRegionIdChanged () {
      const me = this;

      if (!me.regionId) {
        me.apps = [];
        me.isListLoaded = false;
        return;
      }

      let wait = me.wait();

      me.getApplications().then(
        apps => {
          me.stopWait(wait);
          me.apps = apps;
          me.isListLoaded = true;
        },
        fault => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );

    },

    onShowRoutings (transactionId) {
      const
         me = this,
         wait = me.wait();

      me.getRoutings(transactionId).then(
        routings => {
          me.stopWait(wait);
          me.routings = routings;
          me.isModalVisible = true;
        },
        fault => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );

    },

    getAppFormName(app) {
      // console.log(app)
      // let 
      //   apptypeid = 'RFP' 

      return './res/pla/Form-' + app.applicationTypeId + '-' + this.regionId  + '.pdf'
    },

    onEdit (appId) {
      let route = {
        name: 'lms4530',
        query: {
          regionId: this.regionId,
          accountCode: this.accountCode,
          appId: appId
        }
      };

      this.go(route);
    },

    onUpload (appId) {
      let route = {
        name: 'lms4520',
        query: {
          regionId: this.regionId,
          accountCode: this.accountCode,
          appId: appId
        }
      };

      this.go(route);
    },

    onButtonMouseDown (e) {
      e.preventDefault();
    },

    // helpers

    getInfoLabelClass (app) {
      return app.transactionId ? 'lams-light' : 'ivory';
    },

    getTrxStatusColorClass (app) {
      if (app.trxStatusId === 'A') { return 'steelblue'; }      // Active
      if (app.trxStatusId === 'P') { return 'mediumpurple'; }   // Pending
      if (app.trxStatusId === 'J') { return 'palevioletred'; }  // Rejected
      if (app.trxStatusId === 'R') { return 'airforceblue'; }   // Released
      if (app.trxStatusId === 'V') { return 'seagreen'; }       // Approved

      // artificial status
      if (app.trxStatusId === 'X') { return 'palevioletred'; }  // Rejected
      if (app.trxStatusId === 'S') { return 'khaki'; }          // Submitted

      return false;
    }

  },

  created () {
    this.accountCode = '';
  },

  mounted () {
    const me = this;

    me.accountCode = me.sym.userInfo.accountCode;

    me.getRegions().then(
      regions => {
        regions.unshift(
          { regionId: 0, regionFullName: '--- Select Region ---', apiHostAddress: null }
        );
        me.regions = regions;
        // error when disconnected to region
        // if (regions.length === 2) { 
        //   me.regionId = regions[1].regionId;
        //   me.onRegionIdChanged();
        // }
      },
      fault => {
        me.showFault(fault);
      }
    );

  }

}

</script>

<style scoped>

.page-title {
  padding: .875rem;
}

.apps {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
}

.info-label {
  text-align: right;
}

.table-scroll {
  overflow-x: auto;
  white-space: nowrap;
  display: block;
}

.table-hidden-row {
  visibility: collapse;
}

.apps td {
  vertical-align: top;
}

</style>